import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import "./style.scss";

const UpdatingPopover = React.forwardRef(
  ({ popper, children, show: _, ...props }, ref) => {
    React.useEffect(() => {
      popper.scheduleUpdate();
    }, [children, popper]);

    return (
      <Popover ref={ref} body {...props}>
        {children}
      </Popover>
    );
  }
);

export default function ScoreView({ children, content }) {
  return (
    <OverlayTrigger
      trigger={["hover", "focus"]}
      overlay={
        <UpdatingPopover id="popover-contained">
          <p className="content">{content}</p>
        </UpdatingPopover>
      }
      placement="auto-end"
    >
      {children}
    </OverlayTrigger>
  );
}
